<template>
  <el-form label-width="auto" label-position="left">
   <div class="el-row--flex" style="column-gap: 22px">
     <el-form-item :label="`${levelIndex[index + 1] + $t('级菜谱类型')}`" v-for="(item, index) in levelList" :key="index">
       <el-input  disabled :value="item" />
     </el-form-item>
   </div>

    <el-form-item :label="`${$t('封面图')}：`">
      <div class="img-list">
        <preview-img :img-url="recipeDetail.cover" :size="120" />
      </div>
    </el-form-item>

    <el-form-item :label="`${$t('菜谱名称')}：`">
      <span>{{ recipeDetail.name || "" }}</span>
    </el-form-item>

    <el-form-item :label="`${$t('菜谱简介')}：`">
      <span>{{ recipeDetail.introduction || "" }}</span>
    </el-form-item>

    <el-form-item :label="`${$t('功能效用')}：`">
      <span>{{ recipeDetail.goodEffect || "" }}</span>
    </el-form-item>

    <el-form-item :label="`${$t('食物理疗（宜用）')}：`">
      <div class="flex" v-for="item in goodEffect" :key="item.code">
        <span>{{ item.name }}</span>
        <div class="flex" style="column-gap: 16px">
          <an-tag
              v-for="child in item.sub"
              :type="effectCodeList.includes(child.code) ? 'primary' : 'default'"
              :key="child.code">{{ child.name || "" }}</an-tag>
        </div>
      </div>
    </el-form-item>

    <el-form-item :label="`${$t('食物禁忌')}：`">
      <span>{{ recipeDetail.badEffect || "" }}</span>
    </el-form-item>

    <el-form-item :label="`${$t('食物理疗（忌用）')}：`">
      <div class="flex mb16" v-for="item in badEffect" :key="item.code">
        <span>{{ item.name }}</span>
        <div class="flex" style="column-gap: 16px">
          <an-tag
              v-for="child in item.sub"
              :type="badEffectCodeList.includes(child.code) ? 'primary' : 'default'"
              :key="child.code">{{ child.name || "" }}</an-tag>
        </div>
      </div>
    </el-form-item>

  </el-form>
</template>

<script>
import AnTag from "@/components/tag/Tag";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

// 食谱宜用/忌用 字典
const recipeTherapyDict = {
  goodEffect: "宜用",
  badEffect: "忌用",
}

export default {
  name: "RecipeStep1",
  components: {PreviewImg, AnTag},
  data() {
    return {
      // 宜用
      goodEffect: [],
      // 食物禁忌
      badEffect: [],
      // 中文
      levelIndex: {
        1: this.$t('一'),
        2: this.$t('二'),
        3: this.$t('三'),
        4: this.$t('四'),
        5: this.$t('五'),
        6: this.$t('六'),
        7: this.$t('七'),
        8: this.$t('八'),
        9: this.$t('九'),
      }
    }
  },
  activated() {
    this.loadRecipeTherapy();
  },
  methods: {
    // 加载食谱理疗分类
    async loadRecipeTherapy() {
      try {
       const res = await request(this.$api.foodPhysioSort.list);
        const list = res.foodPhysioSorts;
       if(Array.isArray(list) && list.length === 2) {
         const [goodEffect, badEffect] = list;
         this.goodEffect = goodEffect?.sub || []
         this.badEffect = badEffect?.sub || []
       } else if(list.length === 1) {
          const [goodEffect] = list;
          this.goodEffect = goodEffect?.sub || []
        }
      }catch(e) {
         console.log(e);
      }
    }
  },
  computed: {
    recipeDetail() {
      return this.$store.state.recipeDetail;
    },
    levelList() {
      return this.recipeDetail?.sortName ?
          this.recipeDetail?.sortName.split(",") : [];
    },
    effectCodeList() {
      if(!this.recipeDetail?.goodEffectCode) return [];
      return this.recipeDetail?.goodEffectCode.split(",");
    },
    badEffectCodeList() {
      if(!this.recipeDetail?.badEffectCode) return [];
      return this.recipeDetail?.badEffectCode.split(",");
    }
  }
}
</script>

<style scoped>

.img-list {
  display: flex;
  gap: 22px;
}

.el-image {
  width: 160px;
  height: 150px;
}

.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

</style>
